var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      class: { "grid-list-md": _vm.isMobile, "grid-list-lg": !_vm.isMobile },
      attrs: { "px-0": "" }
    },
    [
      _c("v-form", { ref: "serviceInformation" }, [
        _vm.action !== "edit" && _vm.action !== "copy" && _vm.signature
          ? _c(
              "div",
              { staticStyle: { "padding-left": "25px" } },
              [
                _c("v-checkbox", {
                  attrs: {
                    id: "userCheckBox",
                    disabled: _vm.providerDisabled(),
                    color: "indigo darken-3",
                    "error-messages": _vm.checkedErrors,
                    messages: _vm.checkedCreate
                      ? this.student.form.serviceInformation.licenseAttestName +
                        " " +
                        _vm.getCurrentDate()
                      : "",
                    label: "Provider Signature"
                  },
                  on: { change: _vm.onUserCheckboxClicked },
                  model: {
                    value:
                      _vm.student.form.serviceInformation.licenseAttestUserId,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.student.form.serviceInformation,
                        "licenseAttestUserId",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression:
                      "student.form.serviceInformation.licenseAttestUserId"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.action === "copy" && _vm.signature
          ? _c(
              "div",
              { staticStyle: { "padding-left": "25px" } },
              [
                _c("v-checkbox", {
                  key: _vm.componentKey,
                  attrs: {
                    id: "userCheckBoxCopy",
                    disabled: _vm.disabledCopy,
                    color: "indigo darken-3",
                    "error-messages": _vm.checkedErrors,
                    messages: _vm.providerCheckCopy
                      ? this.student.form.serviceInformation.licenseAttestName +
                        " " +
                        _vm.getCurrentDate()
                      : "",
                    label: "Provider Signature"
                  },
                  on: { change: _vm.onUserCheckboxClickedCopy },
                  model: {
                    value: _vm.providerCheckCopy,
                    callback: function($$v) {
                      _vm.providerCheckCopy =
                        typeof $$v === "string" ? $$v.trim() : $$v
                    },
                    expression: "providerCheckCopy"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.action === "edit" &&
        this.supervisorFlagsArray.licenseAttestName &&
        _vm.signature
          ? _c(
              "div",
              { staticStyle: { "padding-left": "25px" } },
              [
                _c("v-checkbox", {
                  attrs: {
                    id: "userCheckBox",
                    disabled: _vm.providerDisabled(),
                    color: "indigo darken-3",
                    "error-messages": _vm.checkedErrors,
                    messages: !_vm.checked
                      ? "" +
                        (this.student.form.serviceInformation.licenseAttestName
                          ? this.student.form.serviceInformation
                              .licenseAttestName
                          : this.supervisorFlagsArray.licenseAttestName) +
                        " " +
                        _vm.convertDisplayedDate(
                          this.student.form.serviceInformation.licenseAttestDate
                        )
                      : "",
                    label: "Provider Signature"
                  },
                  on: { change: _vm.onUserCheckboxClicked },
                  model: {
                    value:
                      _vm.student.form.serviceInformation.licenseAttestUserId,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.student.form.serviceInformation,
                        "licenseAttestUserId",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression:
                      "student.form.serviceInformation.licenseAttestUserId"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.action === "edit" &&
        !this.supervisorFlagsArray.licenseAttestName &&
        _vm.signature
          ? _c(
              "div",
              { staticStyle: { "padding-left": "25px" } },
              [
                _c("v-checkbox", {
                  attrs: {
                    id: "userCheckBox",
                    disabled: _vm.providerDisabled(),
                    color: "indigo darken-3",
                    "error-messages": _vm.checkedErrors,
                    messages: _vm.checked
                      ? _vm.student.form.serviceInformation.licenseAttestName +
                        " " +
                        _vm.getCurrentDate()
                      : "",
                    label: "Provider Signature"
                  },
                  on: { change: _vm.onUserCheckboxClicked },
                  model: {
                    value:
                      _vm.student.form.serviceInformation.licenseAttestUserId,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.student.form.serviceInformation,
                        "licenseAttestUserId",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression:
                      "student.form.serviceInformation.licenseAttestUserId"
                  }
                })
              ],
              1
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-aceaaa12", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aceaaa12","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/service-log/form/extended-service-information/extended-service-information.vue
// module id = null
// module chunks = 